import {updateRealTimePrice} from '~/actions/QuoteActions';
import {
  getNameCount,
  getNamesAndNumbersSizes,
  getNumberCount
} from '~/selectors/NamesAndNumbersSelectors';
import {
  anchorColorCount,
  getCurrentColorId,
  getStyleSelections
} from '~/selectors/ProductSelectors';
import {updateProductPrintMinimum} from '~/actions/FundraisingActions';
import {getPostalCode, getQuantitiesJs} from '~/selectors/QuoteSelectors';

import isEqual from 'lodash/isEqual';
import {getSuggestionsArray} from '~/selectors/SuggestionsSelectors';

function stateComparatorFactory(initialState, nextState) {
  return selector => !isEqual(selector(initialState), selector(nextState));
}

export default function realTimePriceUpdater(store) {
  return next => async action => {
    const initialState = store.getState();
    const suggestions = getSuggestionsArray(initialState);
    const result = next(action);
    const isNextSummaryPage =
      action?.type === 'router/LOCATION_CHANGE' &&
      action?.payload?.pathname === '/next/summary';
    if (suggestions.length === 0 && !isNextSummaryPage) {
      return result;
    }
    const nextState = store.getState();
    const selectors = [
      anchorColorCount,
      getCurrentColorId,
      getNameCount,
      getNamesAndNumbersSizes,
      getNumberCount,
      getStyleSelections,
      getQuantitiesJs,
      getPostalCode
    ];

    const stateComparator = stateComparatorFactory(initialState, nextState);
    const isColorCountStale = [anchorColorCount].some(stateComparator);
    const isPriceStale = selectors.some(stateComparator);

    if (isColorCountStale || isNextSummaryPage) {
      await updateProductPrintMinimum(
        getCurrentColorId(nextState),
        store.dispatch,
        store.getState
      );
    }

    if (isPriceStale || isNextSummaryPage) {
      await updateRealTimePrice()(store.dispatch, store.getState);
    }
    return result;
  };
}
